export const config = {
    apiUrl: import.meta.env.VITE_JOB_API_URL
};